// extracted by mini-css-extract-plugin
export var black = "_3x-6";
export var brand = "_3x-1";
export var ddefault = "_3x-0";
export var error = "_3x-3";
export var gray = "_3x-2";
export var highContrast = "_3x-8";
export var outline = "_3x-7";
export var success = "_3x-5";
export var warning = "_3x-4";